import React, { useState } from 'react';
import { Phone, Mail, MapPin, ChevronDown } from 'lucide-react';
import AdmissionForm from '../components/AdmissionForm';
import { BRANCHES, FAQS } from '../data/mock';

export default function Admissions() {
  const [open, setOpen] = useState(0);
  return (
    <div className="fade-in">
      <section className="coral-gradient text-white relative overflow-hidden">
        <div className="absolute inset-0 dotted-bg opacity-60" />
        <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-20 lg:py-24">
          <div className="text-white/90 text-xs font-semibold uppercase tracking-[0.18em]">Admissions Open · 2026–27</div>
          <h1 className="font-serif font-semibold text-5xl md:text-6xl mt-4 leading-[1.05] max-w-4xl">
            Apply for Admission to <span className="gold-text italic">RN Academy.</span>
          </h1>
          <p className="mt-6 text-white/90 text-lg max-w-2xl">Submit the form below and our admissions team will call you within 24 hours to guide you through the next steps.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid lg:grid-cols-5 gap-10">
        <div className="lg:col-span-2 space-y-6">
          <div>
            <h2 className="font-serif text-3xl font-semibold">Get in touch</h2>
            <p className="text-stone-600 mt-2">Talk to our admissions team for academic counselling, prospectus, or to schedule a campus visit.</p>
          </div>

          <div className="bg-white rounded-2xl border border-orange-100 p-6 space-y-5">
            <div className="flex gap-4">
              <div className="w-10 h-10 rounded-xl bg-coral-light text-coral flex items-center justify-center shrink-0"><Phone className="w-5 h-5" /></div>
              <div>
                <div className="text-xs uppercase tracking-wider font-semibold text-stone-500">Call</div>
                <div className="flex flex-wrap gap-x-3 gap-y-1 mt-1">
                  <a href="tel:+919903248390" className="text-coral font-medium hover:underline">99032-48390</a>
                  <a href="tel:+919748881508" className="text-coral font-medium hover:underline">97488-81508</a>
                </div>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="w-10 h-10 rounded-xl bg-coral-light text-coral flex items-center justify-center shrink-0"><Mail className="w-5 h-5" /></div>
              <div>
                <div className="text-xs uppercase tracking-wider font-semibold text-stone-500">Email</div>
                <a href="mailto:contact@rnacademy.org" className="text-coral font-medium hover:underline">contact@rnacademy.org</a>
              </div>
            </div>
            {BRANCHES.map((b) => (
              <div key={b.name} className="flex gap-4">
                <div className="w-10 h-10 rounded-xl bg-coral-light text-coral flex items-center justify-center shrink-0"><MapPin className="w-5 h-5" /></div>
                <div>
                  <div className="text-xs uppercase tracking-wider font-semibold text-stone-500">{b.name === 'Howrah' ? 'Howrah Branch' : 'Behala Branch'}</div>
                  <div className="text-stone-700 text-sm mt-1">{b.address}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-3">
          <AdmissionForm />
        </div>
      </section>

      {/* FAQs */}
      <section className="bg-[#fff1ea]">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 py-20">
          <div className="text-center">
            <div className="text-coral text-xs font-semibold uppercase tracking-[0.18em]">FAQs</div>
            <h2 className="font-serif text-4xl md:text-5xl font-semibold mt-3 leading-tight">Common questions, <span className="italic text-amber-600">answered.</span></h2>
          </div>
          <div className="mt-10 space-y-3">
            {FAQS.map((f, i) => (
              <div key={f.q} className="bg-white rounded-2xl border border-orange-100 overflow-hidden">
                <button
                  className="w-full text-left px-6 py-5 flex items-center justify-between gap-3"
                  onClick={() => setOpen(open === i ? -1 : i)}
                >
                  <span className="font-serif font-semibold text-lg">{f.q}</span>
                  <ChevronDown className={`w-5 h-5 text-coral smooth ${open === i ? 'rotate-180' : ''}`} />
                </button>
                {open === i && (
                  <div className="px-6 pb-5 text-stone-700 leading-relaxed">{f.a}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
